<template>
  <v-container>
    <v-container>
      <h2>
        <v-icon class="mb-1 mr-2">
          mdi-alert-decagram-outline
        </v-icon>
        Urgent &amp; Featured Actions
      </h2>
    </v-container>

    <Loader v-if="loading" />

    <v-container v-else fluid>
      <v-row v-if="hasUrgentOrFeatured">
        <template v-if="urgentActions.length">
          <v-col
            v-for="action in urgentActions"
            :key="action.id"
            cols="12"
            md="4"
            lg="4"
          >
            <ItemCard :item="action" :urgent="true" />
          </v-col>
        </template>
        <template v-if="featuredActions.length">
          <v-col
            v-for="action in featuredActions"
            :key="action.id"
            cols="12"
            md="4"
            lg="4"
          >
            <ItemCard :item="action" />
          </v-col>
        </template>
      </v-row>
      <v-row v-else justify="center">
        <p class="grey--text subheading">
          No Urgent or Featured Actions for {{ filterState }}
        </p>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { Loader, ItemCard } from 'components';

export default {
  name: 'UrgentOrFeaturedActions',

  components: {
    Loader,
    ItemCard,
  },

  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    urgentActions: {
      type: Array,
      default: () => [],
    },
    featuredActions: {
      type: Array,
      default: () => [],
    },
    filterState: {
      type: String,
      default: '',
    },
  },

  computed: {
    hasUrgentOrFeatured() {
      return this.urgentActions.length > 0 || this.featuredActions.length > 0;
    },
  },
};
</script>
